import React, {useState, useEffect} from "react";
// import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
// import Container from "react-bootstrap/Container";
// import "./assets/bootstrap.min.css";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";
import { ToastContainer } from "react-toastify";

const App = () => {
  return (
    <div>
      <AppRoutes />
      <ToastContainer />
    </div>
  );
};

export default App;
